import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Showdataformperson } from "./Showdataformperson";
import { Input, Form } from "antd";
import { isEmpty, set } from "lodash";
import CompanyNoteDrawer from "./CompanyNoteDrawer";
import { contactPersonNoteUpdate } from "services/redux/contact/companypeople/action";

const CheckMark = "assets/svg/checkmark-24.svg";
const cancel = "assets/svg/cross-24.svg";
const edit = "./assets/svg/profile-edit.svg";

const PersonEditNotes = ({  
  personResponseNotes,
  showArrow,
  showAddUpdateDrawer,
  drawerVisibility,
  onAddUpdateClose,
  windowWidth,
  notes,
  setNotes,
}) => {
  // const [notes, setNotes] = useState(true);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const onSubmit = async () => {
    try {
      let values = await form.validateFields();
      dispatch(contactPersonNoteUpdate(personResponseNotes.id, values));
    } catch (errorInfo) {
      console.error("Failed:", errorInfo);
    }
  };

  return (
    <>
      {notes ? (
        <div className={`right__notes ${!showArrow ? "active" : ""}`}>
          <div className="contactsDetails__infonotes">
            <div className="contactDetails__label--infoNotes">
              <span className="contactsDetails--title bold w-100">Notes </span>
              <div>
                <img
                  src={edit}
                  onClick={() => {
                    setNotes(false);
                  }}
                />
              </div>
            </div>
          </div>
          <div>
            <span className="contactsDetails--subtitle bold">
              {personResponseNotes?.notes}
            </span>
          </div>
        </div>
      ) : (
        
          <div className={`right__notes ${!showArrow ? "active" : ""}`}>
            <div className="contactsDetails__infonotes">
            <div
              className="contactDetails__label--infoNotes"
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "0px, 5px",
              }}
            >
                <span className="contactsDetails--title bold w-100">Notes { " "}</span>
                <div className="contactDetails__button">
                  <div>
                    <img
                      src={CheckMark}
                      onClick={() => {
                        setNotes(true);
                        onSubmit();
                      }}
                    />
                  </div>
                  <div>
                    <img
                      src={cancel}
                      onClick={() => {
                        setNotes(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
           
            <div className="editnote-form-wrapper">
            <Form layout="vertical" form={form} name="control-hooks">
              <Form.Item name="notes" rules={[{ required: false }]}>
                <Input.TextArea
                  className="text-area-fullscreen"
                  bordered={false}
                  defaultValue={personResponseNotes?.notes}
                />
              </Form.Item>
            </Form>
          </div>
            </div>
          
       
      )}
      {showArrow ? (
        <div className="right__notes--show">
          <div
            className="email-internal-hide-show"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div className="meetingInfos">
              {/* <div className="email-description">
							<p
								className="main_content"
								dangerouslySetInnerHTML={{
									__html: initialMessage,
								}}
							></p>
						</div> */}
            </div>
            <div
              className="chatmail__header--wrapper-hide chatmail__image"
              style={{ marginLeft: -3 }}
              onClick={() => showAddUpdateDrawer()}
            >
              <img src={edit} />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <CompanyNoteDrawer
        personResponseNotes={personResponseNotes}
        windowWidth={windowWidth}
        drawerVisibility={drawerVisibility}
        onAddUpdateClose={onAddUpdateClose}
      />
    </>
  );
};
export default PersonEditNotes;
